module.exports = __webpack_public_path__ + "img/slider-image-sm-1.69959c7b.jpg";